import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import useEnumValues from 'app/hooks/useEnumValues'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'

import containerRequests from 'app/requests/Container/Container.requests'
import {
    WithId,
} from 'app/types/common.types'

import useGetContainerBySerialNumber from '../../hooks/useGetContainerBySerialNumber'
import ContainerNotes from './ContainerNotes'
import ContainerTemperatureChart from './ContainerTemperatureChart'
import PrintLabelOverview from './PrintLabelOverview'
import getFields from './Overview.fields'
import useStyles from './Overview.styles'

const Overview = ({
    id: serialNumber,
}: Readonly<WithId<string>>) => {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    const {
        LongTermLease: LongTermLeaseRoutes,
    } = useOrderManagementRoutes()

    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetContainerBySerialNumber(serialNumber)

    const longTermLeaseLink = useMemo(() => {
        return data?.currentLongTermLeaseId ? generateSkyNetLink({
            domainPath: LongTermLeaseRoutes.Overview.path,
            params: {
                key: data?.currentLongTermLeaseId,
            },
        }) : null
    }, [
        LongTermLeaseRoutes.Overview.path,
        data?.currentLongTermLeaseId,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                {
                    data?.id
                        ? (
                            <div className={classes.gridWrapper}>
                                <div className={classes.domainObject}>
                                    <DomainObjectForm
                                        name={containerRequests.name}
                                        value={data}
                                        fields={getFields(getAllowedValues, longTermLeaseLink)}
                                        exists
                                        disabled
                                    />
                                </div>
                                <div className={classes.temperatureChart}>
                                    <ContainerTemperatureChart
                                        serialNumber={serialNumber}
                                        defaultAmbientLoggerType={data.defaultAmbientLoggerType}
                                        defaultInternalLoggerType={data.defaultInternalLoggerType}
                                    />
                                </div>
                                <div className={classes.printLabel}>
                                    <PrintLabelOverview
                                        value={data}
                                    />
                                </div>
                                <div className={classes.containerNotes}>
                                    <ContainerNotes id={data?.id} />
                                </div>
                            </div>
                        )
                        : null
                }
            </>
        </StatusHandler>
    )
}

export default Overview
